export const GET_POST_REQUEST = "GET_POST_REQUEST";
export const GET_POST_SUCCESS = "GET_POST_SUCCESS";
export const GET_POST_FAILURE = "GET_POST_FAILURE";


export const ADD_PROFILEPIC_REQUEST = "ADD_PROFILEPIC_REQUEST";
export const ADD_PROFILEPIC_SUCCESS = "ADD_PROFILEPIC_SUCCESS";
export const ADD_PROFILEPIC_FAILURE = "ADD_PROFILEPIC_FAILURE";

export const EDIT_PRODUCT_REQUEST = "EDIT_PRODUCT_REQUEST";
export const EDIT_PRODUCT_SUCCESS = "EDIT_PRODUCT_SUCCESS";
export const EDIT_PRODUCT_FAILURE = "EDIT_PRODUCT_FAILURE";

export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const PATCH_POST_REQUEST = "PATCH_POST_REQUEST";
export const PATCH_POST_SUCCESS = "PATCH_POST_SUCCESS";
export const PATCH_POST_FAILURE = "PATCH_POST_FAILURE";


export const GET_POST_REQUEST1 = "GET_POST_REQUEST1";
export const GET_POST_SUCCESS1 = "GET_POST_SUCCESS1";
export const GET_POST_FAILURE1 = "GET_POST_FAILURE1";

export const ADD_PRODUCT_REQUEST1 = "ADD_PRODUCT_REQUEST1";
export const ADD_PRODUCT_SUCCESS1 = "ADD_PRODUCT_SUCCESS1";
export const ADD_PRODUCT_FAILURE1 = "ADD_PRODUCT_FAILURE1";


export const DELETE_PRODUCT_REQUEST1 = "DELETE_PRODUCT_REQUEST1";
export const DELETE_PRODUCT_SUCCESS1 = "DELETE_PRODUCT_SUCCESS1";
export const DELETE_PRODUCT_FAILURE1= "DELETE_PRODUCT_FAILURE1";

export const  LOGOUT_REQUEST = "LOGOUT_REQUEST";






export const EDIT_PRODUCT_REQUEST1 = "EDIT_PRODUCT_REQUEST1";
export const EDIT_PRODUCT_SUCCESS1 = "EDIT_PRODUCT_SUCCESS1";
export const EDIT_PRODUCT_FAILURE1 = "EDIT_PRODUCT_FAILURE";


export const PATCH_PRODUCT_REQUEST1 = "PATCH_PRODUCT_REQUEST1";
export const PATCH_PRODUCT_SUCCESS1 = "PATCH_PRODUCT_SUCCESS1";
export const PATCH_PRODUCT_FAILURE1 = "PATCH_PRODUCT_FAILURE1";